import { Routes } from "@angular/router";
import { AchievementsComponent } from "./achievements.component";

export const ChallengesAchievementsRouting: Routes = [
    {
        path: '',
        children: [
            {
                path: 'badge',
                children: [
                    {
                        path: ':id',
                        loadComponent: () => import('./achieved-badge/achieved-badge.component').then(component => component.AchievedBadgeComponent)
                    }
                ]
            },
            {
                path: ':id',
                component: AchievementsComponent
            },
        ]
    },
]
